/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import { getEmbedParam } from '../../helpers/layout'
import { i18n } from '../../providers/Locale/localeProvider'
import Content from '../../components/Layout/Content'
import { Trans } from '@lingui/macro'
import Section from '../../components/Section/Section'
import { color, ColorProps, fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'
import styled from 'styled-components'
import { RouteComponentProps } from 'react-router'
import { confirmRequest, getRequestToken } from '../../requests/confirm'
import loadingAnimation from '../../static/animations/loading.json'
import checkAnimation from '../../static/animations/check.json'
import errorAnimation from '../../static/animations/error.json'
import LottieAnimation from '../../components/Utils/LottieAnimation'
import withURLParams, { URLParamsComponentProps } from '../../providers/URLParams/withURLParams'
import { flowRight } from 'lodash'
import { openAppURL } from '../../helpers/general'
import { isMobile } from 'react-device-detect'

const timeOut = 10

interface Props extends ComponentProps, RouteComponentProps<any>, URLParamsComponentProps {
}

interface State {
  isLoading: boolean;
  isConfirmed: boolean,
  isEmbed: boolean;
  loadingMessage: string,
  successMessage: string;
  error: boolean;
  timeOut: number;
}

class Confirm extends React.Component<Props, State> {
  state = {
    isLoading: false,
    isConfirmed: false,
    isEmbed: false,
    loadingMessage: i18n._('Obteniendo solicitud'),
    successMessage: '',
    error: false,
    timeOut: timeOut,
  }

  componentWillMount () {
    this.setState({
      isEmbed: getEmbedParam() !== null
    })
  }

  componentDidMount () {
    this.startConfirmation()
  }

  startConfirmation = async () => {
    this.setState({ isLoading: true })

    try {
      const requestToken  = await this.loadRequestToken()

      if (requestToken.Data.IsConfirmed) {
        this.setState({ successMessage: i18n._('La solicitud ya fue confirmada'), isConfirmed: true })
      } else {
        this.setState({ loadingMessage: i18n._('Confirmando solicitud') })
        const confirmation = await this.confirmRequestToken()
        this.setState({ successMessage: i18n._('Solicitud confirmada con éxito'), isConfirmed: true })
      }

      this.startRedirection()
    } catch (e) {
      this.setState({ error: true })
    } finally {
      this.setState({ isLoading: false })
    }
  }

  startRedirection = () => {

    const interval = setInterval(() => {
      this.setState(state => ({ timeOut: state.timeOut - 1 }), () => {
        const { timeOut } = this.state

        if (timeOut === 0) {
          clearInterval(interval)
          this.redirect()
        }
      })
    }, 1000)
  }

  redirect = () => {
    const { params } = this.props

    if (params && params.returnTo) {
      openAppURL(params.returnTo)
    }
  }

  loadRequestToken = () => {
    const { match } = this.props

    const { token } = match.params

    return getRequestToken({ token })
  }

  confirmRequestToken = () => {
    const { match } = this.props

    const { token } = match.params

    return confirmRequest({ token })
  }

  render () {
    const { isLoading, isEmbed } = this.state
    const { congress } = this.props

    return (
      <Content>
        {this.renderLoading()}
        {this.renderError()}
        {this.renderResult()}
      </Content>
    )
  }

  renderLoading () {
    const { isLoading, loadingMessage } = this.state

    if (isLoading) {
      return (
        <Section>
          <LottieAnimation animation={loadingAnimation} width={200} height={200}/>
          <Message fontSize={3} mb={3}>{loadingMessage}</Message>
        </Section>
      )
    }
  }

  renderError () {
    const { error } = this.state

    if (error) {
      return (
        <Section>
          <LottieAnimation animation={errorAnimation} width={200} height={200}/>
          <Message fontSize={3} mb={3}><Trans>La solicitud ingresada no existe</Trans></Message>
        </Section>
      )
    }
  }

  renderResult () {
    const { isConfirmed, successMessage, timeOut } = this.state
    const { params } = this.props

    const showRedirectMessage = params && params.returnTo && isMobile

    if (isConfirmed) {
      return (
        <Section>
          <LottieAnimation animation={checkAnimation} width={200} height={200}/>
          <Message fontSize={3} mb={3}>{successMessage}</Message>
          {showRedirectMessage && (
            <React.Fragment>
              <RedirectMessage fontSize={1}>
                <Trans>Será redireccionado/a en <strong>{timeOut} segundos</strong>.</Trans>
              </RedirectMessage>
              <Message fontSize={1} mb={3}>
                <Trans>Una vez en la aplicación, espere a que se confirme la verificación.</Trans>
              </Message>
            </React.Fragment>
          )}
        </Section>
      )
    }
  }
}

const Heading = styled.h1<ColorProps & FontSizeProps & SpaceProps>`
  text-align: center;
  
  ${color}
  ${space}
  ${fontSize}
`

const Banner = styled.img<SpaceProps & any>`
  width: 100%;
  border-radius: 5px;
  
  ${({ hidden }) => hidden && 'display: none;'}
  
  ${space}
`

const Message = styled.span<FontSizeProps & SpaceProps>`
  display: block;
  text-align: center;

  ${fontSize}
  ${space}
`

const RedirectMessage = styled.span<FontSizeProps & SpaceProps>`
  display: block;
  text-align: center;
  font-weight: 300;
  
  strong {
    font-weight: 500;
  }

  ${fontSize}
  ${space}
`


export default flowRight([withCongress, withURLParams])(Confirm)
